import axios from "@/api/axios";

const organizationList = (data) => {
    return axios
        .post('/admin/organization/list', {organization: data})
        .then(response => response.data)
}

const organizationFullList = (data) => {
    return axios
        .post('/admin/organization/full-list', {organization: data})
        .then(response => response.data)
}

const organizationCreate = (data) => {
    return axios
        .post('/admin/organization/create', {organization: data})
        .then(response => response.data)
}

const organizationUpdate = (data) => {
    return axios
        .post('/admin/organization/update', {organization: data})
        .then(response => response.data)
}

const managersList = (data) => {
    return axios
        .post('/admin/organization/managers-list', {organization: data})
        .then(response => response.data)
}

const organizationInfo = (data) => {
    return axios
        .post('/admin/organization/info', {organization: data})
        .then(response => response.data)
}

export default {
    organizationList,
    organizationFullList,
    organizationCreate,
    organizationUpdate,
    managersList,
    organizationInfo
}